import React from "react";
import clsx from "clsx";
import styles from "./FormInput.module.scss";

export const InputError = ({ text, className }) => {
  return <p className={clsx(styles.inputError, className)}>{text}</p>;
};
